import React, { useState, useContext, useEffect } from 'react'
import { Formik, Form, useFormikContext } from 'formik'
import * as Yup from 'yup'
import axios from 'axios'

import Field from '@/components/Field'
import Receipt from '@/components/Receipt'
import { StTag } from './style.css'

const LoginSchema = Yup.object().shape({
  email: Yup.string().email('Email inválido').required('Requerido'),
})

const LoginForm = ({
  event,
  tag = false,
  onLogged,
  onTriggerRegister,
  backgroundtype,
}) => {
  const [useragent, setUseragent] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [useremail, setUseremail] = useState(false)
  const [submittedmsg, setSubmittedmsg] = useState({
    title: 'Gracias por ingresar',
    paragraph: 'Ahora puedes continuar',
  })
  const [errorMessage, setErrorMessage] = useState(false)

  useEffect(() => {
    if (typeof window !== `undefined`) {
      setUseragent(window.navigator.userAgent)
    }
  }, [])

  useEffect(() => {
    if (submitted) {
      onLogged(submitted)
    }
  }, [submitted])

  useEffect(() => {
    if (useremail) {
      onTriggerRegister(useremail)
    }
  }, [useremail])

  return (
    <div className="relative">
      {tag && (
        <StTag className="absolute">
          <span className="uppercase text-white bg-rojo-900 px-6 py-4 text-sm">
            Ingresa
          </span>
        </StTag>
      )}
      {submitted ? (
        <Receipt event={event} message={submittedmsg} />
      ) : (
        <Formik
          initialValues={{
            email: '',
          }}
          validationSchema={LoginSchema}
          onSubmit={(values, { setSubmitting }) => {
            axios
              .post('https://strapi.lab.ltnext.com/registerwebinar/login/', {
                email: values.email,
                useragent: useragent,
                webinar: event.id,
              })
              .then(response => {
                console.log(response)
                if (response.status === 200) {
                  setSubmitted(values.email)
                }
              })
              .catch(err => {
                console.log('>>>err', err.response)
                if (err.response.status === 404) {
                  setUseremail(values.email)
                } else {
                  setErrorMessage(err.response.data.message)
                }
              })
          }}>
          {({ isSubmitting, handleSubmit }) => (
            <form className="text-left p-2 sm:p-6" onSubmit={handleSubmit}>
              <Field
                name="email"
                text="Email"
                placeholder="tuemail@empresa.com"
                backgroundtype={backgroundtype}
              />
              {errorMessage && (
                <div className="mt-4">
                  <p>{errorMessage}</p>
                </div>
              )}
              <div className="mt-4">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="block w-full px-4 py-4 border border-transparent text-sm leading-5 font-medium rounded-lg text-white bg-rojo-900 hover:bg-red-500 focus:outline-none focus:shadow-outline-rojo focus:border-rojo-900 active:bg-indigo-900 transition duration-150 ease-in-out">
                  Ingresa
                </button>
              </div>
            </form>
          )}
        </Formik>
      )}
    </div>
  )
}

export default LoginForm
